// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"472":"settings","528":"reports","549":"locations","594":"about","809":"users","983":"products"}[chunkId] || chunkId) + "." + {"112":"dc267c6f","472":"89c52f71","528":"7bcae21e","549":"fc5cacbe","594":"b13c7efb","809":"3629361b","983":"88c85b30"}[chunkId] + ".css";
};